import React from 'react';
import { ExternalLink } from 'lucide-react';

const AuthorCredit = ({ 
  variant = 'default', 
  className = '',
  showIcon = true,
  size = 'md'
}) => {
  const baseClasses = "inline-flex items-center gap-2 transition-all duration-200 hover:scale-105";
  
  const variants = {
    default: "text-gray-600 hover:text-blue-600",
    light: "text-gray-400 hover:text-white",
    dark: "text-gray-700 hover:text-gray-900",
    accent: "text-blue-600 hover:text-blue-800",
    minimal: "text-gray-500 hover:text-gray-700"
  };

  const sizes = {
    sm: "text-xs",
    md: "text-sm", 
    lg: "text-base"
  };

  const iconSizes = {
    sm: "w-3 h-3",
    md: "w-3.5 h-3.5",
    lg: "w-4 h-4"
  };

  return (
    <div className={`${baseClasses} ${variants[variant]} ${sizes[size]} ${className}`}>
      <span>por</span>
      <a 
        href="https://www.linkedin.com/in/marcelotrindadesouza/" 
        target="_blank" 
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1 font-medium underline decoration-1 underline-offset-2 hover:decoration-2"
      >
        /marcelotrindadesouza
        {showIcon && (
          <ExternalLink className={`${iconSizes[size]} opacity-60`} />
        )}
      </a>
    </div>
  );
};

export default AuthorCredit;
